import {
  updateAccount,
  updateAvatar,
  changePassword,
  deleteAccount,
  getCountries,
  getCities,
} from './action';

export { settingsReducer } from './reducer';
export { watchSettings } from './saga';
export { UPDATE_ACCOUNT, DELETE_ACCOUNT } from './types';

export const settingsActions = {
  updateAccount,
  updateAvatar,
  changePassword,
  deleteAccount,
  getCountries,
  getCities,
};
